import { notification } from 'antd'

const axiosErrorHelper = (e) => {
  let errMessage = 'Something goes wrong. Please, try again later.'
  if (e.response) {
    errMessage = e.response.data.message
  }
  notification.error({
    message: 'Error',
    description: errMessage,
  })
  return true
}

export default axiosErrorHelper
